<div class="checkout-page">

  <div class="checkout-container">

    <div class="checkout-card">

      <h1>
        Adicionar Informação do PIX
      </h1>

      <p class="subtitle">
        Informe os dados do titular do pagamento
      </p>


      <div class="form-grid">

        <div class="campo">

          <label for="nome">
            Nome
          </label>

          <input
            id="nome"
            type="text"
            placeholder="Nome"
            [(ngModel)]="nome"
            maxlength="50"
            autocomplete="given-name"
            oninput="this.value = this.value.replace(/[0-9]/g, '')"
          />

        </div>

        <div class="campo">

          <label for="sobrenome">
            Sobrenome
          </label>

          <input
            id="sobrenome"
            type="text"
            placeholder="Último nome"
            [(ngModel)]="sobrenome"
            maxlength="50"
            autocomplete="family-name"
            oninput="this.value = this.value.replace(/[0-9]/g, '')"
          />

        </div>

        <div class="campo campo-full">

          <label for="cpf">
            CPF
          </label>

          <input
            id="cpf"
            type="text"
            placeholder="000.000.000-00"
            [(ngModel)]="cpf"
            maxlength="14"
            inputmode="numeric"
            autocomplete="off"
            (input)="formatarCpf()"
          />

        </div>

      </div>

      <div class="actions">

        <button
          type="button"
          class="btn-voltar"
          (click)="voltar()"
        >
          Voltar
        </button>


        <button
          type="button"
          class="btn-pagar"
          (click)="continuar()"
        >
          Ir para Pagamento
        </button>

      </div>

    </div>

    <div class="resumo-card">


      <div class="resumo-topo">

        <img
          [src]="dados?.quartoImagem"
          [alt]="dados?.quartoNome"
        />

        <div>

          <h3>
            {{ dados?.quartoNome }}
          </h3>

          <p>
            {{ descricaoAcomodacao }}
          </p>

        </div>

      </div>

      <div class="resumo-linha">

        <strong>
          Datas
        </strong>

        <span>
          {{ formatarData(dados?.checkIn) }}
          -
          {{ formatarData(dados?.checkOut) }}
        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Hóspedes
        </strong>

        <span>

          {{ adultos }}
          adulto(s)

          <ng-container
            *ngIf="criancas > 0"
          >
            e
            {{ criancas }}
            criança(s)
          </ng-container>

          <ng-container
            *ngIf="animais > 0"
          >
            e
            {{ animais }}
            animal(is)
          </ng-container>

        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Noites
        </strong>

        <span>
          {{ quantidadeNoites }}
        </span>

      </div>

      <div class="resumo-linha">

        <strong>
          Preço total
        </strong>

        <span class="valor">

          R$
          {{ valorTotal | number:'1.2-2' }}

        </span>

      </div>

    </div>

  </div>

</div>
